// @ts-nocheck
import { Button } from 'react-bootstrap'
import { useDispatch } from 'react-redux';
import {
    setPayloadSliderFalse,
} from '../../../../../store/MissionSlice';
const PayloadSlider = ({ payloadSliderData }) => {

    const dispatch = useDispatch();


    return (
        <div className="right-slider-box">
            <div className="slider-header">
                <h4>HW Device Details</h4>
            </div>
            <div className="slider-content">
                {/*<div className="common-card-box w-100" style={{display:'flex', position:"absolute", top: 100,}}>*/}
                <div className="common-card-box w-100">
                    <div className="common-card-header flex-column d-flex align-items-baseline">
                        {payloadSliderData?.['user_data']?.['payload_name']}
                    </div>
                    <div className="common-card-footer" style={{ color: 'rgba(255,255,255,0.7)' }}>
                        <div className="d-flex flex-column">
                            <span><span className="temp-label">Payload Type </span>: {payloadSliderData?.['atmos-data']?.['component_specific_attributes']['payloadType']}</span>
                            {payloadSliderData?.['atmos-data']?.['component_specific_attributes']['payloadSubType'] !== '' && <span><span className="temp-label">Payload SubType </span>: {payloadSliderData?.['atmos-data']?.['component_specific_attributes']['payloadSubType']}</span>}
                            {payloadSliderData?.['atmos-data']?.['component_specific_attributes']['payloadDetails'] !== '' && <span><span className="temp-label">Payload Details </span>: {payloadSliderData?.['atmos-data']?.['component_specific_attributes']['payloadDetails']}</span>}
                            <span><span className="temp-label">Size </span>: {payloadSliderData?.['atmos-data']?.['product-cookie']['Size'] + ' U'}</span>
                            <span><span className="temp-label">Mass </span>: {(payloadSliderData?.['atmos-data']?.['weight_in_gms'] > 999) ?
                                ((payloadSliderData?.['atmos-data']?.['weight_in_gms'] / 1000) + ' kg')
                                : (payloadSliderData?.['atmos-data']?.['weight_in_gms'] + ' gm')}</span>
                            <span><span className="temp-label">Peak Power </span>: {payloadSliderData?.['atmos-data']?.['max_power_consumption_in_watts'] + ' W'}</span>
                            {payloadSliderData?.['atmos-data']?.['product-cookie']?.['Supported Interface'] && <span><span className="temp-label">Suported Interfaces </span>: {payloadSliderData?.['atmos-data']?.['product-cookie']?.['Supported Interface']}</span>}
                        </div>
                        <div className="d-flex flex-column">
                            {payloadSliderData?.['atmos-data']?.['component_specific_attributes']['typeSpecificParams'] &&
                                Object.keys(payloadSliderData?.['atmos-data']?.['component_specific_attributes']['typeSpecificParams'])?.length > 0 &&
                                Object.keys(payloadSliderData?.['atmos-data']?.['component_specific_attributes']['typeSpecificParams']).map((k, i) => {

                                    return (
                                        <span className='d-flex ' key={i}><span className="temp-label">{k}</span>: <span className='d-flex flex-wrap flex-1 ms-1'>
                                            {k === 'GSD' ? (payloadSliderData?.['atmos-data']?.['component_specific_attributes']?.['typeSpecificParams']?.[k] + ' m') :
                                                k === 'Swath' ? (payloadSliderData?.['atmos-data']?.['component_specific_attributes']?.['typeSpecificParams']?.[k] + ' km') :
                                                    k === 'Frequency Bands' ? payloadSliderData?.['atmos-data']?.['component_specific_attributes']?.['typeSpecificParams']?.[k].map((band, index) => (
                                                        <span className='d-flex'>{band} {payloadSliderData?.['atmos-data']?.['component_specific_attributes']?.['typeSpecificParams']?.[k].length !== index + 1 && '|'}</span>
                                                    ))
                                                        : payloadSliderData?.['atmos-data']?.['component_specific_attributes']?.['typeSpecificParams']?.[k]}</span>
                                        </span>
                                    )
                                })}
                        </div>
                        <div className="d-flex flex-column">
                            {payloadSliderData?.['atmos-data']?.['component_specific_attributes']['additionalParams'] &&
                                Object.keys(payloadSliderData?.['atmos-data']?.['component_specific_attributes']['additionalParams'])?.length > 0 &&
                                Object.keys(payloadSliderData?.['atmos-data']?.['component_specific_attributes']['additionalParams']).map((k, i) => {
                                    return <span key={i} className='d-flex gap-1'>
                                        <span className="temp-label">{k}</span> : {
                                            payloadSliderData?.['atmos-data']?.['component_specific_attributes']['additionalParams'][k]
                                        }
                                    </span>
                                })}
                        </div>
                        <div className='d-flex'><span className="temp-label">Interface </span>: <span className='d-flex flex-wrap ms-1'>
                            {payloadSliderData?.['atmos-data']?.['component_specific_attributes']?.['interfaces'].map((item, i) => (
                                <span className='d-flex ps-1' key={i}>{item} {payloadSliderData?.['atmos-data']?.['component_specific_attributes']?.['interfaces']?.length !== i + 1 && ' | '}</span>
                            ))}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className='slider-footer'>
                <Button
                    variant="primary"
                    type="button"
                    className="btn btn-primary pt-1 pb-1 pe-6 ps-6 me-3 fs-14"
                    onClick={() => {
                        dispatch(setPayloadSliderFalse())
                    }}
                >
                    Close
                </Button>
            </div>
        </div>
    )
}

export default PayloadSlider
